import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { isPlatformBrowser } from '@angular/common';
import { FuncionService } from '../../servicios/funcion.service';
import { environment } from '../../../environments/environment.prod';
import { Direccion, User } from '../../utilidades/utilidades';
import { Router, ActivatedRoute } from '@angular/router';
import { IPayPalConfig, ICreateOrderRequest } from 'ngx-paypal';

declare var $: any;
// declare var Stripe: any;
declare var SrPago: any;

@Component({
	selector: 'app-carrito',
	templateUrl: './carrito.component.html',
	styleUrls: ['./carrito.component.css']
})
export class CarritoComponent implements OnInit {

	public payPalConfig ? : IPayPalConfig;
	newUser:User;
	step:number = 1;
	uuid:string;
	inputMes:string = "Mes";
	inputAnio:string = "Año";
	inputColonia:string = "Colonia";
	newVenta:any = { detalle:[] };
	tituloTalla:string = "Seleccione una talla";
	tituloColor:string = "Seleccione un color";
	mensajeSesion = environment.alerta.acceso.session;
	tituloComprados:string = "Otros clientes también se llevaron";
	listaComprados:any[] = [];
	SrPago:any;
	listaMeses:any[] = [{ id: "01", nombre: "Enero" }, { id: "02", nombre: "Febrero" }, { id: "03", nombre: "Marzo" }, { id: "04", nombre: "Abril" }, { id: "05", nombre: "Mayo" }, { id: "06", nombre: "Junio" }, { id: "07", nombre: "Julio" }, { id: "08", nombre: "Agosto" }, { id: "09", nombre: "Septiembre" }, { id: "10", nombre: "Octubre" }, { id: "11", nombre: "Noviembre" }, { id: "12", nombre: "Diciembre" }];
	listaAnios:any[] = [];
	newDireccion:Direccion = {
		id:0,
		calle:"",
		exterior:"",
		interior:"",
		codigoPostal:"",
		colonia:{ id:0, nombre:"", options:[] },
		municipio:"",
		ciudad:"",
		estado:"",
		pais:"",
		longitud:"",
		latitud:"",
		guardar:true,
		valido:false,
		referencia:""
	};
	newPago:any = {
		tarjeta:"",
		cvc:"",
		mes:"",
		anio:"",
		nombre:""
	}
	listaColonias:any[] = [];
	responseColonias:any = {};

	showModalAcceso:boolean = false;
	tipoPago:number = 1;
	guardarTarjeta:boolean = false;

	listaDirecciones:any[] = [];

	listaServicios:any = [];

	envio:any = { id:-1, costo:0.00 };

	password:string = "";
	newUsuario:User = {
		username:"",
		session:false,
		nombre:"",
		security:{},
		suscrito:false,
		saldo:"",
		puntos:"",
		divisa:"",
		totalProductos:0
	};

	editarDireccion:boolean = true;

	showDetalle:boolean = false;

	valorCupon:string = "";

	mes:string = '0' + (new Date().getMonth() + 1).toString().slice(-2);
	anio:string = new Date().getFullYear().toString();

	allAvailables:boolean = true;

	constructor( 
		private newFuncionService:FuncionService, 
		private newActivatedRoute:ActivatedRoute, 
		private newRouter:Router,
		private newTitle: Title,
		@Inject(PLATFORM_ID) private platformId: Object,
	) {
		
	}

	ngOnInit() {
		var newFecha = new Date();
		for (var i = newFecha.getFullYear(); i <= (newFecha.getFullYear() + 10); i++) {
			this.listaAnios.push({ id: i, nombre: `${i}` });
		}
		this.newTitle.setTitle("Carrito de compras");
		this.newFuncionService.setNewMensaje( "Cargando productos de tu carrito de compras..." );
		this.uuid = this.newFuncionService.currentUuidValue;
		
		this.newFuncionService.fnCargarComprados({})
		.subscribe( (response:any) =>{
			if( response.success ){
				this.listaComprados = response.lista;
			}
		});

		this.newUser = this.newFuncionService.currentUserValue;

		if( this.newUser.session ){
			this.fnCargarDirecciones();
		}
		this.fnInformacionCarrito();
	}

	fnInformacionCarrito(){
		this.newFuncionService.setNewMensaje( "Cargando productos de tu carrito de compras..." );
		this.newFuncionService.fnCargarCarrito( {venta:{ uuid:this.uuid }} )
		.subscribe( (response:any) =>{
			
			this.newFuncionService.setNewMensaje( null );
			if( response.success ){
				this.newVenta = response.informacion;
				
				if( this.newVenta.direccion.id > 0 && this.newFuncionService.currentUserValue ){
					this.editarDireccion = false;
				}

				this.newVenta.total += this.envio.costo;

				this.newVenta.supertotal = this.newVenta.total;
				this.newVenta.detalle.forEach( (newItem:any) =>{

					newItem.currentProducto.cantidadBack = newItem.currentProducto.cantidad;

					if( newItem.colores.length > 1 ){
						newItem.tieneColores = true;
					}else{
						if( newItem.tallas.length > 1 ){
							newItem.listaTallas = newItem.tallas;
						}	
					}
					if( newItem.tallas.length > 1 ){
						newItem.tieneTallas = true;
					}
					this.fnCargarPreview( newItem );
				});

				this.fnProductosNoDisponibles();
			}
		});
	}

	fnCargarPreview( newProducto ){
		this.newFuncionService.fnCargarPreview( {inventarioDetalle:{id:newProducto.currentProducto.talla.id}} )
		.subscribe( (response:any) =>{
			if( response.success ){
				if( response.galeria.length > 0 ){
					newProducto.fotografia = response.galeria[0];
				}
			}
		});
	}

	fnCargarTallas( newVentaDetalle, id ){
		newVentaDetalle.listaTallas = newVentaDetalle.tallas.filter( newItem => newItem.inventarioId === id );

		let currentTalla = newVentaDetalle.listaTallas.filter( newItem => newItem.id === newVentaDetalle.currentProducto.talla.id );

		if( !currentTalla ){
			newVentaDetalle.currentProducto.talla = newVentaDetalle.listaTallas[0];
		}

		this.fnUpdateProductoCarrito( newVentaDetalle );
	}

	fnSeleccionColor( newColor ){

		let newVentaDetalle = this.newVenta.detalle.find( newItem => newItem.id === newColor.ventaDetalleId );

		if( newColor.id !==  newVentaDetalle.currentProducto.color.id ){
			newVentaDetalle.currentProducto.color = newColor;
		}
		this.fnCargarTallas( newVentaDetalle, newColor.id );
	}

	fnSeleccionTalla( newTalla ){
		let newVentaDetalle = this.newVenta.detalle.find( newItem => newItem.id === newTalla.ventaDetalleId );

		if( newTalla.id !==  newVentaDetalle.currentProducto.talla.id ){
			var sumaCantidad = newVentaDetalle.currentProducto.cantidad;

			this.newVenta.detalle.forEach( function(newItem){
				if( newItem.id !== newTalla.ventaDetalleId ){
					if( newItem.currentProducto.talla.id === newTalla.id ){
						sumaCantidad += newItem.currentProducto.cantidad;
					}
				}
			});
			newVentaDetalle.currentProducto.talla = newTalla;
			if( newTalla.stock < sumaCantidad ){
				newVentaDetalle.currentProducto.cantidad = 1;
			}
			this.fnUpdateProductoCarrito( newVentaDetalle );
		}
	}

	/* FUNCIONES CANTIDADES */
	fnUpdateProductoCarrito( newDetalleInventario ){

		let findObject = newDetalleInventario.tallas.find( newItem => newItem.id === newDetalleInventario.currentProducto.talla.id )

		if( findObject ){
			newDetalleInventario.currentProducto.impuesto = findObject.impuesto;
			newDetalleInventario.currentProducto.sku = findObject.sku;
			newDetalleInventario.currentProducto.descuento = findObject.descuento;
		}

		if( newDetalleInventario.currentProducto.talla.precio ){
			newDetalleInventario.precio = newDetalleInventario.currentProducto.talla.precio;
			newDetalleInventario.descuento = newDetalleInventario.currentProducto.talla.descuento;
		}
		let newRequest = { 
			ventaDetalle:{ 
				id: newDetalleInventario.id, 
				inventarioDetalle:{ 
					id: newDetalleInventario.currentProducto.talla.id, 
					cantidad:newDetalleInventario.currentProducto.cantidad, 
					precio:newDetalleInventario.precio, 
					descuento: newDetalleInventario.descuento 
				} 
			} 
		};

		this.newFuncionService.setNewMensaje( "Actualizando productos de tu carrito de compras" );

		this.newFuncionService.fnUpdateVentaDetalle( newRequest ).subscribe( (response:any) =>{
			this.newFuncionService.setNewMensaje(null);
			if( response.success ){
				this.fnInformacionCarrito();
			}
		});

		this.fnProductosNoDisponibles();
	}

	fnCambiarCantidad(  newDetalleInventario, aumento ){
		if( aumento ){
			// let newCurrent = this.newFuncionService.fnFilterByElement( newDetalleInventario.tallas, "id", newDetalleInventario.currentProducto.talla.id )[0];
			if( newDetalleInventario.currentProducto.cantidad < newDetalleInventario.currentProducto.stock ){
				newDetalleInventario.currentProducto.cantidad = newDetalleInventario.currentProducto.cantidad + 1;
				this.fnUpdateProductoCarrito( newDetalleInventario );
			}
		}else{
			if( newDetalleInventario.currentProducto.cantidad > 1 ){
				newDetalleInventario.currentProducto.cantidad = newDetalleInventario.currentProducto.cantidad - 1;
				this.fnUpdateProductoCarrito( newDetalleInventario );
			}else{
				this.fnEliminarProducto(newDetalleInventario);
			}
		}
	}

	fnValidateCantidad( newDetalleInventario ){
		if( newDetalleInventario.currentProducto.cantidad < 1 || newDetalleInventario.currentProducto.cantidad > newDetalleInventario.currentProducto.stock ){
			newDetalleInventario.currentProducto.cantidad = newDetalleInventario.currentProducto.cantidadBack;
			this.newFuncionService.setNewAlerta( environment.alerta.producto.cantidad );
		}else{
			this.fnUpdateProductoCarrito( newDetalleInventario );
		}
	}


	fnContinuarCompra( newStep ){
		if( newStep === 3 ){
			this.fnCambiarFormaPago(2);
	

			if( this.newVenta.direccion.id === 0 ){
				if( this.newDireccion.colonia.id > 0 && this.newDireccion.referencia != "" ){
					this.newDireccion.valido = true;
				}
			}

			if( this.newDireccion.valido || this.newVenta.direccion.id > 0 ){
				if( this.newUser.session ){
					var newRequest = {
						venta:{ 
							uuid:this.newFuncionService.currentUuidValue, 
							direccion:{}
						}
					};
					if( this.newVenta.direccion.id > 0 ){
						newRequest.venta.direccion = this.newVenta.direccion;
					}else{
						newRequest.venta.direccion = this.newDireccion;
					}
					this.newFuncionService.fnVincularDireccionVenta( newRequest )
					.subscribe( (response:any) =>{
						if( response.success ){
							this.step = newStep;
							this.loadPasarelaPagos(false);
						}
					});
				}else{
					this.newFuncionService.setNewAlerta(environment.alerta.acceso.session);
					this.showModalAcceso = true;
				}			
			}else{
				if( this.newDireccion.referencia === "" ){
					this.newFuncionService.setNewAlerta(environment.alerta.direccion.referencia);
				}else{
					this.newFuncionService.setNewAlerta(environment.alerta.direccion.empty);
				}
			}
		}else{
			if( this.newUser.session ){
				this.step = newStep;
				if( this.step === 2 ){
					// this.fnLimpiarCarrito();
					this.fnCargarDirecciones();
					if( this.newVenta.direccion.id > 0 ){
						let newDireccion = this.listaDirecciones.find( newItem => newItem.id === this.newVenta.direccion.id );
						this.fnSeleccionDireccion( newDireccion );
					}
				}
			}else{
				// this.newFuncionService.setNewAlerta(environment.alerta.acceso.session);
				this.showModalAcceso = true;
			}
		}
		window.scroll(0,0);
	}



	/* FUNCIONES ACCESO */
	fnAccionModal( display ){
		this.showModalAcceso = display;
	}

	fnVerificarUsuario(){
		if( this.newUsuario.username === "" ){
			this.newFuncionService.setNewAlerta( environment.alerta.acceso.username.vacio );
		}else if( !environment.validacion.correo.test( this.newUsuario.username ) ){
			this.newFuncionService.setNewAlerta( environment.alerta.acceso.username.formato );
		}else if( this.password === "" ){
			this.newFuncionService.setNewAlerta( environment.alerta.acceso.password );
		}else{
			this.newFuncionService.setNewMensaje( "Validando tus datos de cuenta" );
			this.newFuncionService.fnIniciarSesion( { username:this.newUsuario.username, password:this.password } )
			.subscribe(( response:any ) => {
				this.newUsuario.security = response;
				this.newFuncionService.fnVerifyUser( this.newUsuario );
				this.showModalAcceso = false;
				this.newFuncionService.setNewMensaje( null );
				this.newFuncionService.fnVincularVentaCliente({ venta:{ uuid:this.newFuncionService.currentUuidValue } })
				.subscribe( (response:any) =>{
					if( response.success ){
						this.newUser = this.newFuncionService.currentUserValue;
						this.newFuncionService.fnTotalProductosCarrito({ venta:{ uuid: this.newFuncionService.currentUuidValue } })
						.subscribe( (response:any) =>{
							if( response.success ){
								this.newFuncionService.currentUserValue.totalProductos = response.totalProductos;
							}
						});
						this.fnInformacionCarrito();
						this.fnCargarDirecciones();
					}
				});
			}, ( error:any ) => {
				this.newFuncionService.setNewAlerta( this.newFuncionService.fnGetNotificationError( error.status ) );
			});
		}
	}


	/* FUNCION DIRECCIONES */
	fnCambiarDireccion( newOpcion ){
		this.editarDireccion = newOpcion;
		if( newOpcion ){
			this.newVenta.direccion = { id:0 };
		}else{
			this.newDireccion = {id:0,calle:"",exterior:"",interior:"",codigoPostal:"",colonia:{ id:0, nombre:"", options:[] },municipio:"",ciudad:"",estado:"",pais:"",longitud:"",latitud:"",guardar:true,valido:false, referencia:""};
		}
		this.listaServicios = [];
	}

	fnCotizarPaqueteria(){
		var newCodigoPostal = "";
		if( this.newVenta.direccion.id > 0 ){
			newCodigoPostal = this.newVenta.direccion.direccion.codigoPostal;
		}else{
			newCodigoPostal = this.newDireccion.codigoPostal;
		}
		
		if( newCodigoPostal != "" ){
			setTimeout( () =>{
				this.listaServicios = [];
				this.newFuncionService.setNewMensaje( "Cotizando paqueterías..." );
				this.newFuncionService.fnCotizarEnvio( { codigoPostal:newCodigoPostal, carrito:this.newFuncionService.currentUuidValue } )
				.subscribe( (response:any) =>{
					this.newFuncionService.setNewMensaje( null );
					// console.log(response.success) 
					if( response.success ){
						if( response.code === -1 ){
							this.fnCotizarPaqueteria();
						}else{
							if( response.code === 1 ){
								this.envio = { id:-1, costo:this.newVenta.costoEnvio };
							}else if( response.code === 0 ){
								var listaBack = [];
									response.servicios.forEach( (newServicio)=>{
										var newLista = newServicio.servicios.sort(function (a, b) {
											if (a.costo > b.costo) {
												return 1;
											}
											if (a.costo < b.costo) {
												return -1;
											}
											return 0;
										});

										listaBack.push({
											costo:newLista[0].costo,
											servicio:newServicio
										});
									});

									listaBack.sort(function (a, b) {
										if (a.costo > b.costo) {
											return 1;
										}
										if (a.costo < b.costo) {
											return -1;
										}
										return 0;
									}).forEach( (newItem)=>{
										this.listaServicios.push( newItem.servicio );
									});
								// this.listaServicios = response.servicios;
								this.listaServicios.forEach( function( newItem ){ newItem.collapse = true; } );
																
								if( this.listaServicios.length === 0 ) {
									if( this.newVenta.direccion.id > 0 ) {
										this.newVenta.direccion.id = 0
									} else {
										this.newDireccion.codigoPostal = "";
									}

									this.newFuncionService.setNewAlerta( environment.alerta.direccion.codigoPostal.sinServicio );
								}else{
									let newPaqueteria = this.listaServicios[ 0 ];
									newPaqueteria.collapse = false;
									this.envio = newPaqueteria.servicios[0];
								}
								
							}
							this.newVenta.total = this.newVenta.supertotal
							this.newVenta.total += this.envio.costo;
						}
					}else{
						this.fnCotizarPaqueteria();
					}
				})
			});
		}
	}

	fnCargarColonias(){
		if( environment.validacion.codigoPostal.test( this.newDireccion.codigoPostal ) ){
			this.newFuncionService.setNewMensaje( "Buscando colonias del código postal..." );
			this.newFuncionService.fnBuscarColonias( { colonia:{ codigoPostal: this.newDireccion.codigoPostal  }} )
			.subscribe( (response:any) =>{
					this.newFuncionService.setNewMensaje( null );
				if( response.success ){
					this.listaColonias = [];
					this.responseColonias = response.data;
					response.data.colonias.forEach( (newItem:any) =>{
						this.listaColonias.push( {id:newItem.id, nombre:newItem.colonia} );
					});
					this.listaColonias = this.newFuncionService.fnOrdenarLista(this.listaColonias, "nombre");
					this.fnCotizarPaqueteria();
				}
			});
		}else{
			if( this.newDireccion.codigoPostal !== "" ){
				this.newFuncionService.setNewAlerta( environment.alerta.direccion.codigoPostal.formato );
			}
		}
	}

	fnSeleccionColonia( newColonia ){
		this.newDireccion.municipio = this.responseColonias.municipio;
		this.newDireccion.estado = this.responseColonias.estado;
		this.newDireccion.pais = this.responseColonias.pais;
		this.newDireccion.ciudad = this.responseColonias.ciudad;
		this.newDireccion.colonia = newColonia;
		if( this.newDireccion.referencia !== "" ){
			this.newDireccion.valido = true;
		}
	}


	fnCambiarTipoEnvio( newTipoEnvio ){
		this.envio = newTipoEnvio;
		this.newVenta.total = this.newVenta.supertotal
		this.newVenta.total += this.envio.costo;
	}

	fnCambiarFormaPago( newTipoPago ){
		this.tipoPago = newTipoPago;
		if( this.tipoPago === 2 ){
			this.fnConfigPaypal();
		}else{
			this.loadPasarelaPagos(false);
		}
	}

	fnCambiarPaso( newStep ){
		if( this.step > newStep && this.step < 4 ){
			this.step = newStep;
		}
	}

	fnCargarDirecciones(){
		if( this.newFuncionService.currentUserValue ){
			this.newFuncionService.fnCargarDirecciones({})
			.subscribe( (response:any) =>{
				if( response.success ){
					this.listaDirecciones = response.lista;
				}
			});
		}
	}

	fnSeleccionDireccion( newDireccion ){
		if( newDireccion ){
			this.newVenta.direccion = newDireccion;
			this.fnCotizarPaqueteria();
		}
	}

	fnAplicarCupon(){
		if( this.valorCupon !== "" ){
			this.newFuncionService.fnAplicarCupon({ cupon:{ uuid:this.newFuncionService.currentUuidValue, codigo:this.valorCupon } })
			.subscribe( (response:any) =>{
				if( response.success ){
					this.newFuncionService.setNewAlerta( environment.alerta.cupones.success );
					this.fnInformacionCarrito();
				}else{
					var cuponFail = {
						mensaje: response.message,
						titulo: "Pawerful Pet Shop - Cupon de descuento",
						estilo: "alerta-warning",
						icono: 'fas fa-exclamation-circle'
					}
					this.newFuncionService.setNewAlerta(cuponFail);
				}
			});
		}
		
	}


	fnEliminarProducto( newProducto ){
		this.newFuncionService.setNewMensaje( "Quitando producto de tu carrito de compras..." );
		this.newFuncionService.fnEliminarProducto({ venta:{ producto:{ id:newProducto.id } } })
		.subscribe( (response:any) =>{
			this.newFuncionService.setNewMensaje( null );
			if( response.success ){
				this.fnInformacionCarrito();
				this.newFuncionService.fnTotalProductosCarrito({ venta:{ uuid: this.newFuncionService.currentUuidValue } })
				.subscribe( (response:any) =>{
					if( response.success ){
						this.newFuncionService.currentUserValue.totalProductos = response.totalProductos;
					}
				});
			}
		});

		this.fnProductosNoDisponibles();
	}


	fnConfigPaypal(){
		let newThis = this;
		let newTotal = Math.round(this.newVenta.total * 100)/100;
		this.payPalConfig = {
			currency: this.newVenta.divisa,
			clientId: environment.clientIdPaypal,
			createOrderOnClient: (data) => <ICreateOrderRequest>{
				intent: 'CAPTURE',
				purchase_units: [{
					description: environment.tituloPedido,
					reference_id: this.newFuncionService.currentUuidValue,
					amount: {
						currency_code: this.newVenta.divisa,
						value: `${newTotal}`
					}
				}]
			},
			advanced: {
				commit: 'true'
			},
			style: {
				label: 'paypal',
				layout: 'vertical'
			},
			onApprove: (data, actions) => {
				actions.order.get().then(details => {
					if( details.status === "APPROVED" ){
						this.newFuncionService.setNewMensaje( "Validando y guardando los datos de tu compra" );
					}
				});
			},
			onClientAuthorization: (data) => {
				if( data.status === "COMPLETED" ){
					/*let newRequest = {
						venta:{
							uuid:this.newFuncionService.currentUuidValue,
							forma:1,
							creacion:new Date(data.update_time).toString(),
							monto:this.newVenta.total,
							transaccion:data.id,
							numeroTarjeta:null,
							direccion:this.newVenta.direccion
						},
						envio:this.envio
					}*/
	
					var newDataRequest = {
						envio: newThis.envio,
						card: {},
						extra: {
							telefono: "",
							monto: newThis.newVenta.total,
							operacion: false, 
							divisa: "",
							marca: "Pawerful",
							numeroServicio: "",
							recurrente: false,
							promocion: "",
							descripcion: "Compra de productos en Pawerful.com"
						},
						billing: {
							nombre: "",
							apellido: "",
							correo: "",
							direccion: "",
							colonia: "",
							codigoPostal: "",
							cuidad: "",
							estado: "",
							pais: ""
						},
						venta: {
							direccion: newThis.newVenta.direccion,
							uuid: newThis.newFuncionService.currentUuidValue,
							creacion: new Date(data.update_time).toString(),
							forma: 1,
							monto: newThis.newVenta.total,
							numeroTarjeta: null,
							transaccion: data.id,
							paymentId: data.purchase_units[0]['payments'].captures[0].id
						}
					}

					// this.newFuncionService.fnTerminarVenta( newRequest )
					this.newFuncionService.fnTerminarVenta( newDataRequest )
					.subscribe( (response:any) =>{
						this.newFuncionService.setNewMensaje( null );
						if( response.success ){
							this.newFuncionService.createUuid();
							this.newFuncionService.setNewAlerta(environment.alerta.venta.success);
							this.newRouter.navigate([ 'mi-cuenta', 'mis-pedidos' ]);
						}else{
							this.newFuncionService.setNewMensaje( null );
							this.newFuncionService.setNewAlerta( environment.alerta.venta.fail );
						}
					});
				}
			},
			onCancel: (data, actions) => {
				// console.log('OnCancel', data, actions);
			},
			onError: err => {
				// console.log(err);
			},
			onClick: (data, actions) => {
				// console.log('onClick', data, actions);
			}
		};


	}



	/*loadStripe() {
		window['Stripe'].setPublishableKey( environment.clientIdStripe );
		this.newStripe = (<any>window).Stripe;
		
	  	this.newPago = {tarjeta:"",cvc:"",mes:"",anio:"", nombre:""};
	}*/
	loadPasarelaPagos( init : Boolean ){
		this.SrPago = (<any>window).SrPago;
		if( this.SrPago ){
			this.SrPago.setLiveMode( false );
			this.SrPago.setPublishableKey( environment.clientIdSrPago );
		}else{
			this.newFuncionService.setNewAlerta( environment.alerta.pago.validacion.load );
		}

		this.newPago = {
			card: {
				number: "",
				holder_name: "",
				exp_month: {id:0},
				exp_year: {id:0},
				cvv: "",
			},
			extra: {
				telefono: "",
				monto: "",
				operacion: false,
				divisa: "MXN",
				recurrente: false,
				marca: "Tienda Pawerful",
				promocion: "",
				descripcion: "Compra de productos en Pawerful.com"
			},
			billing: {
				nombre: "",
				apellido: "",
				correo: "",
				direccion: "",
				colonia: { id: 0 },
				codigoPostal: "",
				ciudad: "",
				estado: "",
				pais: ""
			}
		};
	}

	fnPago(){
		if( this.SrPago ){
			this.newFuncionService.setNewMensaje( "Procesando pago de tu pedido." );
			let newUser = this.newFuncionService.currentUserValue;
			this.newPago.extra.monto = this.newVenta.total;

			var formatoTarjeta = false;
		  	if(
		  		environment.validacion.visa.test( this.newPago.card.number ) ||
	    		environment.validacion.masterCard.test( this.newPago.card.number ) ||
	    		environment.validacion.americanExpress.test( this.newPago.card.number )
		  	){
		  		formatoTarjeta = true
		  	}

			var vigenciaTarjeta = true;
		  	var newFecha = new Date();
		  	var currentMonth = newFecha.getMonth() + 1;
		  	if( this.newPago.card.exp_month.id > 0 && this.newPago.card.exp_year.id > 0 ){
		  		if( newFecha.getFullYear() === this.newPago.card.exp_year.id ){
		  			if( currentMonth >= parseInt( this.newPago.card.exp_month.id ) ){
		  				vigenciaTarjeta = false;
		  			}
		  		}
		  	}

			var newAlerta = null;
		  	if( this.newPago.billing.nombre === "" ){
		  		newAlerta = environment.alerta.pago.validacion.nombre;
		  	}else if( this.newPago.billing.apellido === "" ){
		  		newAlerta = environment.alerta.pago.validacion.paterno;
		  	}else if( this.newPago.card.number === "" ){
		  		newAlerta = environment.alerta.pago.validacion.tarjeta;
		  	}else if( !formatoTarjeta ){
		  		newAlerta = environment.alerta.pago.validacion.tarjeta;
		  		this.newPago.card.number = "";
		  	}else if( this.newPago.card.exp_month.id === 0 ){
		  		newAlerta = environment.alerta.pago.validacion.expiracion;
		  	}else if( this.newPago.card.exp_year.id === 0 ){
		  		newAlerta = environment.alerta.pago.validacion.expiracion;
		  	}else if( !vigenciaTarjeta ){
		  		newAlerta = environment.alerta.pago.validacion.expiracion;
		  		this.newPago.card.exp_month = {id:0};
		  		this.newPago.card.exp_year = {id:0};
		  	}else if( this.newPago.card.cvv === "" ){
		  		newAlerta = environment.alerta.pago.validacion.cvc;
		  	}else if( !environment.validacion.cvc.test( this.newPago.card.cvv ) ){
		  		newAlerta = environment.alerta.pago.validacion.cvc;
		  		this.newPago.card.cvv = "";
		  	}else if( this.newPago.billing.direccion === "" ){
		  		newAlerta = environment.alerta.pago.validacion.direccion;
		  	}else if( this.newPago.billing.codigoPostal === "" ){
		  		newAlerta = environment.alerta.pago.validacion.codigoPostal.vacio;
		  	}else if( !environment.validacion.codigoPostal.test( this.newPago.billing.codigoPostal ) ){
		  		newAlerta = environment.alerta.pago.validacion.codigoPostal.formato;
		  		this.newPago.billing.codigoPostal = "";
		  	}else if( this.newPago.billing.colonia.id === 0 ){
		  		newAlerta = environment.alerta.pago.validacion.colonia;
		  	}

			if( newAlerta ){
				this.newFuncionService.setNewMensaje( null );
				this.newFuncionService.setNewAlerta( newAlerta );
			}else{
				this.newPago.card.holder_name = this.newFuncionService.fnLatinize( `${this.newPago.billing.nombre} ${this.newPago.billing.apellido}` );
				
				this.SrPago.token.create({
					number: `${this.newPago.card.number}`,
					holder_name: this.newPago.card.holder_name,
					exp_month: `${this.newPago.card.exp_month.id}`,
					exp_year: `${this.newPago.card.exp_year.id}`,
					cvv: this.newPago.card.cvv,
				}, (response)=>{
					var newRequest = {
						envio: this.envio,
						card: response.token,
					  	extra: this.newPago.extra,
					  	billing: this.newPago.billing,
					  	venta: {
						  	direccion: this.newVenta.direccion,
							uuid: this.newFuncionService.currentUuidValue,
							creacion: new Date().toString(),
							forma: 2,
							monto: this.newVenta.total,
							numeroTarjeta: null,
							transaccion: ""
					  	}
					};
					newRequest.billing.colonia = newRequest.billing.colonia.nombre

					this.newFuncionService.fnTerminarVenta( newRequest ).subscribe( (response:any) =>{
						this.newFuncionService.setNewMensaje( null );
					  	if( response.success ){
							this.newFuncionService.createUuid();
							this.newFuncionService.setNewAlerta(environment.alerta.venta.success);
							this.newRouter.navigate([ 'mi-cuenta', 'mis-pedidos' ]);
					  	}else{
							newRequest.billing.colonia = {id:0};
							var newMotivo = "";
							if( response.mensaje ){
								newMotivo = `<p class="alerta-motivo">Motivo: ${response.mensaje}</p>`;
							}
							this.newFuncionService.setNewMensaje( null );
							this.newFuncionService.setNewAlerta({
								mensaje: `${environment.alerta.venta.fail.mensaje} ${newMotivo}`,
								titulo: environment.alerta.venta.fail.titulo,
								estilo: environment.alerta.venta.fail.estilo,
								icono: environment.alerta.venta.fail.icono
							});
						}
				  	});
				}, ( error )=>{
					this.newFuncionService.setNewMensaje( null );
					if (error.message === "number") {
						if( this.newPago.card.number === "" ){
							newAlerta = newAlerta = environment.alerta.pago.validacion.tarjeta;;
						}else{
							newAlerta = newAlerta = environment.alerta.pago.validacion.tarjeta;;
							this.newPago.card.number = "";
						}
				  	} else if (error.detail === "exp_month") {
					  	newAlerta = newAlerta = environment.alerta.pago.validacion.expiracion;
						this.newPago.card.exp_month = {id:0};
				  	} else if (error.detail === "exp_year") {
					  	newAlerta = newAlerta = environment.alerta.pago.validacion.expiracion;
					  	this.newPago.card.exp_year = {id:0};
				  	} else if (error.message === "cvv") {
					  	if( this.newPago.card.cvv === "" ){
							newAlerta = newAlerta = environment.alerta.pago.validacion.cvc;
						}else if( !environment.validacion.cvc.test( this.newPago.card.cvv ) ){
							newAlerta = newAlerta = environment.alerta.pago.validacion.cvc;
						}
						this.newPago.card.cvv = "";
				  	} else if (error.message === "cardholder_name") {
					  	newAlerta = newAlerta = environment.alerta.pago.validacion.nombre;
					  	this.newPago.billing.nombre = "";
					  	this.newPago.billing.apellido = "";
				  	}
				  	this.newFuncionService.setNewAlerta( newAlerta );
				});
			}
		}else{
			this.newFuncionService.setNewAlerta( environment.alerta.pago.validacion.load )
		}
	}

	/*fnPagoStripe(){
		let newThis = this;
		let newUser = this.newFuncionService.currentUserValue;

		// if(!window['Stripe']) {
		if(!this.newStripe) {
			newThis.newFuncionService.setNewAlerta( environment.alerta.pago.validacion.load );
			// console.log('Oops! Stripe did not initialize properly.');
			return;
		}

		var validarForm = true;

		if( !this.newStripe.card.validateCVC( this.newPago.cvc ) ){
			validarForm = false;
			this.fnControlError( 'cvc' );
			newThis.newFuncionService.setNewAlerta( environment.alerta.pago.validacion.cvc );
		}
		
		if( !this.newStripe.card.validateExpiry( this.newPago.mes, this.newPago.anio ) ){
			validarForm = false;
			this.fnControlError( 'mes' );
			this.fnControlError( 'anio' );
			newThis.newFuncionService.setNewAlerta( environment.alerta.pago.validacion.expiracion );
		}
		
		if( !this.newStripe.card.validateCardNumber( this.newPago.tarjeta ) ){
			validarForm = false;
			this.fnControlError( 'tarjeta' );
			newThis.newFuncionService.setNewAlerta( environment.alerta.pago.validacion.tarjeta );
		}
		
		if( this.newPago.nombre === "" ){
			validarForm = false;
			this.fnControlError( 'nombre' );
			newThis.newFuncionService.setNewAlerta( environment.alerta.pago.validacion.nombre );
		}
		
		if( validarForm ){
			this.newFuncionService.setNewMensaje( "Procesando pago de tu pedido." );
			let newThis = this;
			this.newStripe.card.createToken({
				number: this.newPago.tarjeta,
				exp_month: this.newPago.mes,
				exp_year: this.newPago.anio,
				cvc: this.newPago.cvc
			}, (status: number, response: any) => {
				if (status === 200) {

					var newDataRequest = {
						envio: newThis.envio,
						card: response,
						extra: {
							telefono: "",
							monto: newThis.newVenta.total,
							operacion: false, 
							divisa: "",
							marca: "Pawerful",
							numeroServicio: "",
							recurrente: false,
							promocion: "",
							descripcion: "Compra de productos en Pawerful.com"
						},
						billing: {
							nombre: "",
							apellido: "",
							correo: "",
							direccion: "",
							colonia: "",
							codigoPostal: "",
							cuidad: "",
							estado: "",
							pais: ""
						},
						venta: {
							direccion: newThis.newVenta.direccion,
							uuid: newThis.newFuncionService.currentUuidValue,
							creacion: new Date(response.created * 1000).toString(),
							forma: 2,
							monto: newThis.newVenta.total,
							numeroTarjeta: null,
							transaccion: response.id
						},
						shipping: {
							shippingCharges: newThis.envio.costo,
							shippingFirstName: "",
							shippingMiddleName: "",
							shippingLastName: "",
							shippingEmailAddress: "",
							shippingAddress: newThis.newVenta.direccion.direccion.direccion1,
							shippingAddress2: newThis.newVenta.direccion.direccion.direccion2,
							shippingCity: newThis.newVenta.direccion.direccion.area1,
							shippingState: newThis.newVenta.direccion.direccion.area1,
							shippingPostalCode: newThis.newVenta.direccion.direccion.codigoPostal,
							shippingCountry: newThis.newVenta.direccion.direccion.codigoPais,
							shippingPhoneNumer: "",
							shippingMethod: "mail",
							shippingDeadline: ""
						}
					}


					// console.log(response)
					// newThis.newFuncionService.fnTerminarVenta( newRequest )
					newThis.newFuncionService.fnTerminarVenta( newDataRequest )
					.subscribe( (response:any) =>{
						newThis.newFuncionService.setNewMensaje( null );
						if( response.success ){
							// console.warn(response)
							newThis.newFuncionService.createUuid();
							newThis.newFuncionService.setNewAlerta(environment.alerta.venta.success);
							newThis.newRouter.navigate([ 'mi-cuenta', 'mis-pedidos' ]);
						}else{
							newThis.newFuncionService.setNewMensaje( null );
							newThis.newFuncionService.setNewAlerta( environment.alerta.venta.fail );
						}
					});
				} else {
					newThis.newFuncionService.setNewMensaje( null );
					newThis.newFuncionService.setNewAlerta( environment.alerta.venta.pago.fail );
				}
			});
		};



	}*/


	fnControlError( newName ){
		if (isPlatformBrowser(this.platformId)){
			$(`*[name*='${newName}']`).addClass("invalid");
		}
	}

	fnClearControl( newEvent ){
		if (isPlatformBrowser(this.platformId)){
			$(`*[name*='${newEvent.target.name}']`).removeClass("invalid");
		}
	}

	watchCodigoPostal( newEvent ) {
		if( newEvent !== "" ){
			if(environment.validacion.codigoPostal.test( newEvent ) ){
				$(".codigoPostal").blur();
				this.newFuncionService.setNewMensaje( "Buscando colonias del código postal..." );
				this.newFuncionService.fnBuscarColonias( { colonia:{ codigoPostal: newEvent  }} )
				.subscribe( (response:any) =>{
						this.newFuncionService.setNewMensaje( null );
					if( response.success ){
						this.listaColonias = [];
						this.responseColonias = response.data;
						response.data.colonias.forEach( (newItem:any) =>{
							this.listaColonias.push( {id:newItem.id, nombre:newItem.colonia} );
						});
						this.listaColonias = this.newFuncionService.fnOrdenarLista(this.listaColonias, "nombre");
					}else{
						this.newPago.billing.codigoPostal = "";
					}
				});
			}else{
				if( newEvent.length === 5 ){
					this.newPago.billing.codigoPostal = "";
				}
			}
		}
  	}
	fnSeleccionColoniaTarjeta( newColonia ){
		this.newPago.billing.municipio = this.responseColonias.municipio;
		this.newPago.billing.estado = this.responseColonias.estado;
		this.newPago.billing.pais = this.responseColonias.pais;
		this.newPago.billing.ciudad = this.responseColonias.ciudad;
		this.newPago.billing.colonia = newColonia;
	}
	fnMesSeleccion( newMes ){
		this.newPago.card.exp_month = newMes;
	}
	fnAnioSeleccion( newAnio ){
		this.newPago.card.exp_year = newAnio;
	}



	fnProductosNoDisponibles(){
		let _lista = this.newVenta.detalle.filter(it => it.disponible === false)
		if( _lista.length > 0 ){
			this.allAvailables = false;
		}else{
			this.allAvailables = true;
		}
		return _lista;
	}
	/*fnLimpiarCarrito(){
		this.newFuncionService.fnLimpiarCarrito({venta:{ uuid:this.uuid }})
			.subscribe( (response:any) => {
                console.log(".subscribe -> response", response);
				return;
			} );
	}*/
}
